import * as React from 'react';
import { NavigationLink } from './NavigationLink';
import { useState, useEffect } from 'react';
import { CTAButton } from './CTAButton';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

export const NavigationMenu: React.FC = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [isMobile, setIsMobile] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();

	// Check if screen is mobile on mount and when window resizes
	useEffect(() => {
		const checkIfMobile = () => {
			setIsMobile(window.innerWidth < 768);
		};

		// Initial check
		checkIfMobile();

		// Add event listener
		window.addEventListener('resize', checkIfMobile);

		// Cleanup
		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);

	// Close menu when switching from mobile to desktop
	useEffect(() => {
		if (!isMobile) {
			setIsMenuOpen(false);
		}
	}, [isMobile]);

	return (
		<div className='flex items-center my-auto'>
			{/* Desktop Navigation */}
			<div
				className={`${isMobile ? 'hidden' : 'flex gap-6 items-end min-h-3'}`}
			>
				{/* <NavigationLink
					text='Home'
					to='/'
					isActive={location.pathname === '/'}
				/> */}
				<NavigationLink
					text='Services'
					to='/services'
					isActive={location.pathname === '/services'}
				/>
				<NavigationLink
					text='About'
					to='/about'
					isActive={location.pathname === '/about'}
				/>
				<NavigationLink
					text='Blog'
					to='/blog'
					isActive={location.pathname === '/blog'}
				/>
				<NavigationLink
					text='Contact'
					to='/contact'
					isActive={location.pathname === '/contact'}
				/>
			</div>

			{/* Mobile Burger Menu Button */}
			{isMobile && (
				<button
					className='relative z-20 p-2'
					onClick={() => setIsMenuOpen(!isMenuOpen)}
					aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
				>
					<div
						className={`w-6 h-0.5 bg-neutral-800 transition-all ${
							isMenuOpen ? 'rotate-45 translate-y-1.5' : ''
						}`}
					></div>
					<div
						className={`w-6 h-0.5 bg-neutral-800 my-1.5 transition-opacity ${
							isMenuOpen ? 'opacity-0' : ''
						}`}
					></div>
					<div
						className={`w-6 h-0.5 bg-neutral-800 transition-all ${
							isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''
						}`}
					></div>
				</button>
			)}

			{/* Mobile Navigation Overlay */}
			{isMobile && isMenuOpen && (
				<div className='fixed inset-0 z-10 bg-white flex flex-col items-center justify-center h-screen w-screen'>
					<div className='flex flex-col gap-6 items-center w-full'>
						{/* <NavigationLink
							text='Home'
							to='/'
							isActive={location.pathname === '/'}
						/> */}
						<NavigationLink
							text='Services'
							to='/services'
							isActive={location.pathname === '/services'}
						/>
						<NavigationLink
							text='About'
							to='/about'
							isActive={location.pathname === '/about'}
						/>
						<NavigationLink
							text='Blog'
							to='/blog'
							isActive={location.pathname === '/blog'}
						/>
						<NavigationLink
							text='Contact'
							to='/contact'
							isActive={location.pathname === '/contact'}
						/>
						<div className=' mt-8 max-w-xs mx-auto'>
							<CTAButton
								text='Explore services'
								bgColor='yaap-yellow'
								textColor='yaap-white'
								onClick={() => navigate('/services')}
							/>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};
